/* eslint-disable import/no-cycle */
// TODO remove import cycles
import { modalAccountTabs } from '../tabs/tabs';
import Form from '../form/form';
import Validation from '../validation/validation';
import Helpers from '../js/helpers';
import ModalSearch from '../modal-search/modal-search';
import Filter from '../filter/filter';
import Header from '../../mobile/header/header';
import ModalUnavailabilityEtalon from '../modal-unavailability-etalon/modal-unavailability-etalon';
/* eslint-enable import/no-cycle */

/**
 * Open modal:
 *      add class to element 'js-modal-open'
 *      add data attribute 'data-modal-link'
 *
 *      EXAMPLE: <button class="js-modal-open" data-modal-link="default">Open Modal</button>
 *
 * Add modal before </body>
 * In 'modal__wrapper' add container with content,
 * also add class 'js-modal-content' and 'data-modal="default"'
 */

export default new class Modal {
  constructor() {
    this.speed = 300;

    this.successHash = '#send';

    this.modalOpened = 'modal_opened';
    this.modalContent = 'js-modal-content';
    this.modalClose = 'js-modal-close';
    this.modalServicesClose = 'js-modal-close_services';
    this.modalContentActive = '_active';
    this.modal = 'modal';

    this.$modal = $(`.${this.modal}`);
    this.sliders = {};
    this.bodyScrollFlag = false;
    this.bindEvents();
    this.showSuccessModal();
  }

  bindEvents() {
    $(document).on('click', '.js-modal-open', (e) => {
      e.preventDefault();

      let $modalLink = $(e.target);
      $modalLink = !$modalLink.hasClass('js-modal-open') ? $modalLink.closest('.js-modal-open') : $modalLink;

      const targetDataValue = $modalLink.attr('data-modal-link');
      const currentModal = $(`.${this.modalContent}[data-modal='${targetDataValue}']`);
      const activeTab = $modalLink.attr('data-active-tab');

      // close modal unavailability etalon
      if ($modalLink.hasClass('_etalon-popup')) {
        ModalUnavailabilityEtalon.closeModalUnavailabilityEtalon($modalLink);
      }

      this.openModal($modalLink, currentModal, targetDataValue, activeTab);
    });

    /* Hide modal by button with className this.modalClose */
    this.$modal.on('click', (e) => {
      const $currentElement = $(e.target);
      const $currentModal = $currentElement.closest(`.${this.modal}`);

      if (!$currentElement.hasClass(`${this.modalClose}`)) return;

      this.hideModal();
      this.clearPopupFormData($currentElement);

      if (Helpers.getModalType($currentModal) === 'search-result' && !$currentElement.hasClass(this.modalServicesClose)) {
        ModalSearch.resetModalSearchFilter($currentModal.find(ModalSearch.modalSearch));
      }
    });

    /* Hide modal by ESC */
    $(document).keyup((e) => {
      if (e.keyCode === 27) {
        const $searchModal = $('.modal-search').closest('.js-modal-content._active');
        const $currentModal = $searchModal.closest(`.${this.modal}`);

        this.hideModal();
        this.clearPopupFormData();

        if (Helpers.getModalType($currentModal) === 'search-result') {
          ModalSearch.resetModalSearchFilter($currentModal.find(ModalSearch.modalSearch));
          Filter.toggleFilterTooltip();
        }

        /* clear search on page when close modal with search results */
        if ($searchModal.closest(`.${this.modalOpened}`).length) {
          $('.js-searchInput').val('');
        }
      }
    });
  }

  /**
     * show success modal after send data from modal-feedback or modal-become-author
     */
  showSuccessModal() {
    const { hash } = window.location;
    const $successModal = $(`.${this.modalContent}[data-modal='modal-success']`);

    if (`${hash}` === `${this.successHash}`) {
      this.openModal(null, $successModal);
    }
  }

  /**
     * Clears all values in inputs in the popup, hide error msgs
     *
     * @param $closePopupBtn jquery elem of close popup btn
     */
  clearPopupFormData($closePopupBtnParam = null) {
    let $closePopupBtn = $closePopupBtnParam;

    if (!$closePopupBtn) {
      const $openedModal = this.getOpenedModal();

      if (!$openedModal) return;
      $closePopupBtn = $openedModal.find(`.${this.modalClose}`);
    }

    const formInModalArr = $closePopupBtn.closest('.modal__box').find('form');

    setTimeout(() => {
      if (formInModalArr.length) {
        for (let i = 0; i < formInModalArr.length; i += 1) {
          Form.clearForm($(formInModalArr[i]));
        }
      }
    }, this.speed);
  }

  /**
     * Find last opened modal
     *
     * @returns $lastOpenedModal - jquery obj of opened modal
     */
  getOpenedModal() {
    let $lastOpenedModal;
    const openedModalsArr = $(`.${this.modal}.${this.modalOpened}`);
    const timeStampsArr = [];

    // if there is one opened modal - returns it, as last opened
    if (openedModalsArr.length === 1) {
      $lastOpenedModal = $(openedModalsArr[0]);
      return $lastOpenedModal;
      // if there is more than one opened modal
    }
    // gets all opened modal timestamps
    for (let i = 0; i < openedModalsArr.length; i += 1) {
      timeStampsArr.push(parseInt($(openedModalsArr[i]).attr('data-time-stamp'), 10));
    }

    // finds last opened modal by its timeStamp
    const latestTimeStamp = Math.max.apply(null, timeStampsArr);
    const lastOpenedModalIndex = timeStampsArr.indexOf(latestTimeStamp);
    $lastOpenedModal = $(openedModalsArr[lastOpenedModalIndex]);

    return $lastOpenedModal;
  }

  /**
     * Detect opened modal, and hide it
     */
  hideModal() {
    const $currentModal = this.getOpenedModal();
    if (typeof $currentModal !== 'undefined') {
      if (Helpers.isMobile()) {
        Helpers.toggleScrollBodyMobile(null, true);
      } else {
        this.toggleScrollBody();
        this.bodyScrollFlag = false;
      }

      // reload page on info popup 'success trial activated' close
      if ($currentModal.find('[data-modal-type="success-trial-activated"]').length) {
        window.location = window.location;
        $currentModal.find('.modal-info').attr('data-modal-type', '');
      }

      $currentModal.fadeOut(this.speed, () => {
        // you can write some code here, if you need when modal hide

        // clear hash after close modal-success
        if ($('.modal-success._active').length) {
          window.location.hash = '';
        }

        $currentModal.removeClass(this.modalOpened).find('.modal__wrapper').children().hide();
        $currentModal.find('[data-modal]').removeAttr('tabindex');

        Validation.removeErrorFromFields($currentModal);
      });
    }
  }

  /**
     * Opens modal
     *
     * @param $modalLink - Button, which open modal
     * @param $currentModal - current modal (found necessary content in modal)
     * @param dataModal - data attribute from modal (if you need you can use
     * this value in callback hide/fadeIn function)
     * @param activeTab - data attribute for active tab should be opened in popup
     * from modal (if you need you can use this value in callback hide/fadeIn function)
     * @returns {boolean}
     */
  openModal($modalLink, $currentModal, dataModal = '', activeTab = '') {
    this.bodyScrollFlag = true;
    const $modal = $currentModal.closest(`.${this.modal}`);

    if (Helpers.isMobile()) {
      Header.hideHeader();
      Helpers.toggleScrollBodyMobile(true);
      $currentModal.attr('tabindex', 1);
    }

    this.toggleScrollBody();
    $currentModal.fadeIn(this.speed).addClass(this.modalContentActive);

    if (activeTab) {
      modalAccountTabs.setActiveTab(activeTab);
    }

    $modal.fadeIn(this.speed, () => {
      if (dataModal === 'account') {
        this.initSlider();
      }
    });

    $modal.addClass(this.modalOpened);
    $modal.attr('data-time-stamp', (new Date()).getTime());
    return false;
  }

  /**
     * Hide or show scroll in body
     */
  toggleScrollBody() {
    if (this.bodyScrollFlag){
      const $body = $('body');
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth;

      $body.toggleClass('body_hide-scroll');
      $body.css('padding-right', scrollWidth);
    }
  }

  /**
     * Modal maybe has slider, and this func initialize slider after modal opened
     */
  initSlider() {
    const modalAccountSlider = $('.js-modal-account');

    if (modalAccountSlider.length && typeof this.sliders.accountSlider === 'undefined') {
      this.sliders.accountSlider = true;

      $('.js-modal-account').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    }
  }
}();
